module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(1);

	var angular = __webpack_require__(2);

	var MODULE_NAME = 'rediOpenFinWebLib';

	var angularModule = angular.module(MODULE_NAME, [
	  'redi-common'
	]);

	__webpack_require__(3)(angularModule);
	__webpack_require__(6)(angularModule);
	__webpack_require__(8)(angularModule);
	__webpack_require__(21)(angularModule);

	module.exports = MODULE_NAME;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = require("redi-common-angular");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = require("angular");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function (angularModule) {
	  angularModule
	      .directive('rediWindowFrame', __webpack_require__(4));
	};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = /* @ngInject */ function () {
	  return {
	    restrict: 'E',
	    transclude: true,
	    template: __webpack_require__(5),
	    controller: 'RediWindowFrameController',
	    controllerAs: 'that'
	  };
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var v1="<div class=\"window-frame\" data-ng-class=\"{ 'window-frame-border': that.shouldShowFrame }\"> <div class=\"title-bar\" data-ng-class=\"{ 'title-bar': that.active, 'title-bar-inactive': !that.active }\" data-ng-if=\"that.shouldShowFrame\"> <div class=\"title\">{{that.title}}</div> <div class=\"btn-container\"> <input type=\"button\" class=\"btn-minimize\" data-ng-show=\"that.state !== 'minimized' && that.isMinimizable\" data-ng-click=\"that.minimizeAndHide()\" tabindex=\"-1\"/>\n<input type=\"button\" class=\"btn-maximize\" data-ng-show=\"that.state !== 'maximized' && that.isMaximizable\" data-ng-click=\"that.maximize()\" tabindex=\"-1\"/>\n<input type=\"button\" class=\"btn-restore\" data-ng-show=\"that.state !== 'normal'\" data-ng-click=\"that.restore()\" tabindex=\"-1\"/>\n<input type=\"button\" class=\"btn-close\" data-ng-click=\"that.close()\" tabindex=\"-1\"/> </div> </div> <div data-ng-class=\"{ 'content': that.shouldShowFrame, 'content-without-frame': !that.shouldShowFrame }\"> <div data-ng-transclude></div> </div> </div>";
	angular.module(["ng"]).run(["$templateCache",function(c){c.put("templates/rediWindowFrame.html", v1)}]);
	module.exports=v1;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function (angularModule) {
	  angularModule
	      .controller('RediWindowFrameController', __webpack_require__(7));
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var rediCommon = __webpack_require__(1);

	module.exports = /* @ngInject */ ["$q", "$scope", "$window", "$document", "$interval", "openFinApi", "openFinWebLibFeatures", "rediVersionRepository", "rediVersionCheck", function ($q,
	                                           $scope,
	                                           $window,
	                                           $document,
	                                           $interval,
	                                           openFinApi,
	                                           openFinWebLibFeatures,
	                                           rediVersionRepository,
	                                           rediVersionCheck) {
	  var that = this;

	  rediCommon.initialize();

	  var rediVersion = rediVersionRepository.get();
	  if (rediVersion) {
	    rediVersionCheck.init(rediVersion);
	  }

	  that.UPDATE_STATE_TIMER_INTERVAL_IN_MILLISECOND = 250;
	  that.title = $document[0].title;
	  that.active = true;

	  $scope.$watch(function () {
	    return $document[0].title;
	  }, function (newTitle) {
	    that.title = newTitle;
	  });

	  function onFocus() {
	    that.active = true;
	  }

	  function onBlur() {
	    that.active = false;
	  }

	  $window.addEventListener('focus', onFocus);
	  $window.addEventListener('blur', onBlur);

	  getCurrentWindowOptions().then(function (options) {
	    that.shouldShowFrame = !options.frame;
	    that.isMaximizable = options.maximizable;
	    that.isMinimizable = options.minimizable;
	  });

	  var updateStateInterval = $interval(updateState, that.UPDATE_STATE_TIMER_INTERVAL_IN_MILLISECOND);
	  $scope.$on('$destroy', function () {
	    $window.removeEventListener('focus', onFocus);
	    $window.removeEventListener('blur', onBlur);
	    $interval.cancel(updateStateInterval);
	    rediCommon.cleanup();
	  });
	  updateState();

	  function updateState() {
	    return getCurrentWindowState().then(function (state) {
	      that.state = state;
	    });
	  }

	  that.minimizeAndHide = function () {
	    return getCurrentWindow().then(function (window) {
	      window.minimize();
	      if (openFinWebLibFeatures.enableHideTaskbarIcon === true) {
	        window.hide();
	      }
	    });
	  };

	  that.minimize = function () {
	    return getCurrentWindow().then(function (window) {
	      window.minimize();
	    });
	  };

	  that.maximize = function () {
	    return getCurrentWindow().then(function (window) {
	      window.maximize();
	    });
	  };

	  that.restore = function () {
	    return getCurrentWindow().then(function (window) {
	      window.restore();
	    });
	  };

	  that.close = function () {
	    return getCurrentWindow().then(function (window) {
	      window.close();
	    });
	  };

	  function getCurrentWindowOptions() {
	    return $q(function (resolve, reject) {
	      getCurrentWindow().then(function (window) {
	        window.getOptions(resolve, reject);
	      }, reject);
	    });
	  }

	  function getCurrentWindowState() {
	    return $q(function (resolve) {
	      getCurrentWindow().then(function (window) {
	        window.getState(resolve);
	      });
	    });
	  }

	  function getCurrentWindow() {
	    return openFinApi.getCurrentWindow().then(function (window) {
	      if (isInBrowser(window)) {
	        return $q.reject(window);
	      }
	      return window;
	    });
	  }

	  function isInBrowser(window) {
	    return !window;
	  }
	}];


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function (angularModule) {
	  angularModule
	      .factory('BrowserWindowManager', __webpack_require__(9))
	      .service('externalWindowLauncher', __webpack_require__(10))
	      .factory('openFinApi', __webpack_require__(11))
	      .factory('OpenfinWindowManager', __webpack_require__(14))
	      .factory('taskbarIconUrl', __webpack_require__(16))
	      .service('windowInitParamsRepository', __webpack_require__(17))
	      .service('rediVersionCheck', __webpack_require__(18))
	      .service('rediVersionRepository', __webpack_require__(19))
	      .factory('WindowManager', __webpack_require__(20));
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ ["$q", "$window", function ($q, $window) {

	  function BrowserWindowManager(windowStore) {

	    this.openWindow = function (windowKey, url) {
	      var target = windowStore[windowKey];

	      if (!target.window) {
	        target.window = $q.when($window.open(url, target.name));
	      } else {
	        target.window.then(function (targetWindow) {
	          var targetWindowWasClosed = !targetWindow.parent;
	          if (targetWindowWasClosed) {
	            target.window = $q.when($window.open(url, target.name));
	          } else {
	            targetWindow.location = url;
	          }
	          targetWindow.focus();
	        });
	      }

	      return target.window;
	    };

	    this.closeSelf = function () {
	      window.document.body.innerHTML = 'Windows cannot be closed in browsers other than OpenFin - please close this window manually.';
	    };
	  }


	  return BrowserWindowManager;

	}];


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ ["openFinApi", function (openFinApi) {
	  var that = this;

	  that.launchChartIqWindow = function (params) {
	    openFinApi.publish('open-window', {
	      data: 'ChartIQ',
	      params: params
	    });
	  };
	}];


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(12);
	var windowContainerApi = __webpack_require__(13).windowContainerApi;

	// This service wraps the OpenFin API so that it can be
	// injected. It also provides a stub API so that the app
	// can be run in Chrome - when the OpenFin API is not
	// available, calls to API methods will be logged to the
	// console. When an API method is first used by the app,
	// it should be added to the openFinMethods object below.
	var OPENFIN_API_METHODS = {
	  setClipboard: 'desktop.System.setClipboard',
	  subscribe: 'desktop.InterApplicationBus.subscribe',
	  unsubscribe: 'desktop.InterApplicationBus.unsubscribe',
	  createWindow: 'desktop.Window',
	  getCurrentWindow: 'desktop.Window.getCurrent',
	  publish: 'desktop.InterApplicationBus.publish',
	  send: 'desktop.InterApplicationBus.send'
	};

	module.exports = /* @ngInject */ ["$log", "$q", "$parse", "$interval", "windowInitParamsRepository", function ($log, $q, $parse, $interval,
	                                           windowInitParamsRepository) {
	  if (typeof fin === 'undefined') {
	    $log.warn('OpenFin API is not defined. Any feature leveraging OpenFin will be non-functional.');
	    var fakeApi = _.mapValues(OPENFIN_API_METHODS, function () {
	      return function () {
	        return $q.when(undefined);
	      };
	    });
	    fakeApi.getFin = function () {
	      return $q.reject();
	    };
	    fakeApi.getCurrentWindowName = function () {
	      return windowContainerApi.currentWindowName;
	    };
	    fakeApi.isInOpenFin = false;
	    return fakeApi;
	  }

	  $log.info('Waiting for OpenFin API to be ready...');

	  var intervalPromise = $interval(function () {
	    $log.warn('OpenFin API was not ready after 10s. Waiting for another 10s...');
	  }, 10000);

	  /* global fin */
	  fin.desktop.main(function () {
	    $interval.cancel(intervalPromise);
	    $log.info('OpenFin API is ready');
	  });

	  var api = _.mapValues(OPENFIN_API_METHODS, function (apiMethodPath) {
	    return function () {
	      var apiMethodCallArgs = arguments,
	          apiMethodCallContext = this;

	      return api.getFin().then(function (fin) {
	        var apiMethod = $parse(apiMethodPath)(fin);

	        return apiMethod.apply(apiMethodCallContext, apiMethodCallArgs);
	      });
	    };
	  });

	  api.isInOpenFin = true;

	  api.getFin = function () {
	    var deferred = $q.defer();
	    fin.desktop.main(function () {
	      return deferred.resolve(fin);
	    });
	    return deferred.promise;
	  };

	  api.getFin().then(function (fin) {
	    windowInitParamsRepository.init(api);
	    api.publish('window-ready', {
	      windowName: fin.desktop.Window.getCurrent().name
	    });
	  });

	  api.getCurrentWindowName = function () {
	    return windowContainerApi.currentWindowName;
	  };

	  return api;
	}];


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = require("lodash");

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = require("redi-window-container-web-lib");

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var _ = __webpack_require__(12),
	  logRepository = __webpack_require__(1).logRepository,
	  uuid = __webpack_require__(15);

	module.exports = /* @ngInject */ ["$rootScope", "$q", "$window", "openFinApi", "openFinWebLibFeatures", "taskbarIconUrl", function(
	  $rootScope,
	  $q,
	  $window,
	  openFinApi,
	  openFinWebLibFeatures,
	  taskbarIconUrl
	) {
	  function createWindowWithInitParams(
	    windowConfig,
	    childWindows,
	    target,
	    initParams
	  ) {
	    return $q(function(resolve, reject) {
	      openFinApi.getFin().then(function(fin) {
	        var bus = fin.desktop.InterApplicationBus;
	        var appUuid = fin.desktop.Application.getCurrent().uuid;
	        var name = windowConfig.name;
	        var onWindowReady = function() {
	          bus.send(appUuid, name, "init-window", initParams || {});
	        };
	        bus.subscribe(appUuid, name, "window-ready", onWindowReady);

	        var newWindow = new fin.desktop.Window(
	          windowConfig,
	          function() {
	            logRepository.log("Created window with ID " + windowConfig.name);

	            newWindow.addEventListener("close-requested", function() {
	              // OpenFin API does not provide a way to
	              // explicitly allow the original attempt
	              // to close to succeed if 'close-requested'
	              // is handled, so we must invoke close
	              // again, this time passing true to
	              // force-close.
	              var force = true;
	              newWindow.close(force);
	            });

	            newWindow.addEventListener("closed", function(event) {
	              _.remove(childWindows, function(childWindow) {
	                return childWindow === newWindow;
	              });
	              bus.unsubscribe(appUuid, name, "window-ready", onWindowReady);
	              delete target.window;
	              logRepository.log("Closed window with ID " + event.name);

	              $rootScope.$digest();
	            });

	            resolve(newWindow);
	          },
	          function() {
	            reject("Failed to create window");
	          }
	        );
	      });
	    });
	  }

	  function getWindowConfigWithPosition(windowConfig, positionOffset) {
	    return $q(function(resolve, reject) {
	      if (
	        !positionOffset ||
	        positionOffset.x === undefined ||
	        positionOffset.y === undefined
	      ) {
	        resolve(windowConfig);
	      } else {
	        openFinApi.getFin().then(function(fin) {
	          var currentWindow = fin.desktop.Window.getCurrent();
	          currentWindow.getOptions(
	            function(options) {
	              var positionConfig = {
	                defaultLeft: options.x + positionOffset.x,
	                defaultTop: options.y + positionOffset.y
	              };
	              var windowConfigWithPositionOffset = _.defaults(
	                {},
	                windowConfig,
	                positionConfig
	              );
	              resolve(windowConfigWithPositionOffset);
	            },
	            function() {
	              reject("Failed to get current window options");
	            }
	          );
	        });
	      }
	    });
	  }

	  function goToUrlAndShowAndFocus(window, url) {
	    window.getNativeWindow().location = url;
	    return showAndFocus(window);
	  }

	  function showAndFocus(window) {
	    /*
	      Facing an issue where OpenFin functions "setAsForeground()" and "bringToFront()" would not
	      always work for bringing the window to the front, especially in front of a non-openfin window,
	      we are setting alwaysOnTop to true, then false, to guarantee it is on top of all other windows,
	      (This workaround was given by OpenFin).
	     */
	    return adjustWindowDisplay(window)
	      .then(function(window) {
	        return updateOptions(window, { alwaysOnTop: true });
	      })
	      .then(function(window) {
	        return show(window);
	      })
	      .then(function(window) {
	        return updateOptions(window, { alwaysOnTop: false });
	      })
	      .then(function(window) {
	        return focus(window);
	      });
	  }

	  function adjustWindowDisplay(window) {
	    return $q(function(resolve, reject) {
	      window.getBounds(bounds => {
	        openFinApi.getFin().then(function(fin) {
	          fin.desktop.System.getMonitorInfo(function(monitorInfo) {
	            const currentScreenLeft = monitorInfo.virtualScreen.left;
	            const currentScreenRight = monitorInfo.virtualScreen.right;
	            const currentScreenTop = monitorInfo.virtualScreen.top;
	            const currentScreenBottom = monitorInfo.virtualScreen.bottom;
	            // Check if the current monitor layout is sufficient to display based on the default layout
	            // If the check succeeds, resolve okay
	            // else minimize and restore the defaults on to the current monitor
	            // In case defaults are out of bounds, we need to minimize and restore as openfin does not automatically detect monitor changes.
	            if (
	              currentScreenLeft <= bounds.left &&
	              currentScreenRight >= bounds.right &&
	              currentScreenTop <= bounds.top &&
	              currentScreenBottom >= bounds.bottom
	            ) {
	              resolve(window);
	            } else {
	              window.minimize(function() {
	                window.restore(function() {
	                  resolve(window);
	                }, reject);
	              }, reject);
	            }
	          });
	        });
	      });
	    });
	  }

	  function updateOptions(window, options) {
	    return $q(function(resolve, reject) {
	      return window.updateOptions(
	        options,
	        function() {
	          resolve(window);
	        },
	        reject
	      );
	    });
	  }

	  function focus(window) {
	    return $q(function(resolve, reject) {
	      return window.focus(function() {
	        resolve(window);
	      }, reject);
	    });
	  }
	  function show(window) {
	    var force = true;
	    return $q(function(resolve, reject) {
	      return window.show(
	        force,
	        function() {
	          resolve(window);
	        },
	        reject
	      );
	    });
	  }

	  function OpenfinWindowManager(windowStore, confirmToClose) {
	    if (!_.isFunction(confirmToClose)) {
	      confirmToClose = function() {
	        return true;
	      };
	    }

	    var childWindows = [];

	    openFinApi.getFin().then(function(fin) {
	      var currentWindow = fin.desktop.Window.getCurrent();
	      currentWindow.addEventListener("close-requested", onCloseRequested);
	    });

	    function onCloseRequested() {
	      var result = confirmToClose(childWindows);
	      if (result === true) {
	        closeAll();
	      } else if (_.isFunction(result.then)) {
	        result.then(closeAll);
	      }
	    }

	    function closeAll() {
	      openFinApi.getFin().then(function(fin) {
	        var force = true;
	        _.forEach(childWindows, function(childWindow) {
	          childWindow.close(force);
	        });
	        childWindows = [];
	        fin.desktop.Window.getCurrent().close(force);
	      });
	    }

	    this.openWindow = function(
	      windowKey,
	      url,
	      positionOffsetFromParent,
	      initParams
	    ) {
	      var showTaskbarIcon = !openFinWebLibFeatures.enableHideTaskbarIcon,
	        target = windowStore[windowKey],
	        eventuallyShow = false,
	        windowConfig = _.defaults({}, target.openFinParams, {
	          url: url,
	          name: `${windowKey}-${uuid.v4()}`,
	          resize: true,
	          windowState: "normal",
	          autoShow: true,
	          frame: false,
	          showTaskbarIcon: showTaskbarIcon,
	          taskbarIcon: taskbarIconUrl,
	          contextMenu: false
	        });

	      if (windowConfig.autoShow) {
	        eventuallyShow = true;
	        windowConfig.autoShow = false;
	      }

	      if (target.window) {
	        return goToUrlAndShowAndFocus(target.window, url);
	      }

	      if (target.windowPromise) {
	        return target.windowPromise.then(function(window) {
	          return goToUrlAndShowAndFocus(window, url);
	        });
	      }
	      target.windowPromise = getWindowConfigWithPosition(
	        windowConfig,
	        positionOffsetFromParent
	      ).then(function(windowConfigWithPositionOffset) {
	        return createWindowWithInitParams(
	          windowConfigWithPositionOffset,
	          childWindows,
	          target,
	          initParams
	        );
	      });
	      return target.windowPromise.then(function(window) {
	        target.window = window;
	        target.windowPromise = undefined;

	        childWindows.push(window);

	        if (eventuallyShow) {
	          return showAndFocus(window);
	        }

	        return window;
	      });
	    };

	    this.closeSelf = function() {
	      openFinApi.getFin().then(function(fin) {
	        var force = false;
	        fin.desktop.Window.getCurrent().close(force);
	      });
	    };
	  }

	  return OpenfinWindowManager;
	}];


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = require("node-uuid");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ ["$location", function($location) {
	  return $location.protocol() + '://' + $location.host() + ':' + $location.port() + '/openfin/images/redi.ico';
	}];


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ ["$log", "$q", function ($log, $q) {
	  var deferred = $q.defer();

	  this.init = function (openFinApi) {
	    openFinApi.subscribe('*', 'init-window', function (params) {
	      $log.debug('Received init-window message with params ' + JSON.stringify(params));
	      deferred.resolve(params);
	    });
	  };

	  this.get = function () {
	    return deferred.promise;
	  };
	}];


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(12);

	module.exports = /* @ngInject */ ["openFinApi", function (openFinApi) {
	  var that = this;
	  var currentRediVersion;
	  var MAX_TOKEN_COUNT = 4;
	  var OPENFIN_VERSION_FOR_REDI_17_0 = 6;


	  that.init = function (version) {
	    currentRediVersion = version;
	  };

	  that.hasVersion = function () {
	    return !!currentRediVersion;
	  };

	  that.isExpectingVersionFromRedi = function () {
	    return openFinApi.getFin().then(function (fin) {
	      if (shouldNotExpectVersionFromRedi(fin)) {
	        return false;
	      }
	      return true;
	    });
	  };

	  that.isGreaterThanOrEqualTo = function (checkedVersion) {
	    checkVersionsSetOrThrow(checkedVersion);

	    var currentVersionArray = convertStringToFourDigitNumberArray(currentRediVersion);
	    var checkedVersionArray = convertStringToFourDigitNumberArray(checkedVersion);

	    for (var index = 0; index < MAX_TOKEN_COUNT; ++index) {
	      if (checkIndexIsGreaterThan(currentVersionArray, checkedVersionArray, index)) return true;
	      if (checkIndexIsGreaterThan(checkedVersionArray, currentVersionArray, index)) return false;
	    }

	    return true;
	  };

	  function getOpenFinMajorVersion(fin) {
	    return parseInt(fin.desktop.getVersion().split('.')[0]);
	  }

	  function shouldNotExpectVersionFromRedi(fin) {
	    return getOpenFinMajorVersion(fin) < OPENFIN_VERSION_FOR_REDI_17_0;
	  }

	  function checkVersionsSetOrThrow(checkedVersion) {
	    if (!checkedVersion) {
	      throw new Error('checkedVersion must be set');
	    }
	    if (!currentRediVersion) {
	      throw new Error('currentRediVersion must be set');
	    }
	  }

	  function convertStringToFourDigitNumberArray(versionString) {
	    var versionArray = versionString.split('.');
	    for (var i = 0; i < MAX_TOKEN_COUNT; ++i) {
	      versionArray[i] = Number(versionArray[i]);
	    }
	    return versionArray;
	  }

	  function checkIndexIsGreaterThan(currentVersionArray, checkedVersionArray, index) {
	    return isNaN(currentVersionArray[index]) || currentVersionArray[index] > checkedVersionArray[index];
	  }

	}];


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ function () {
	  var that = this;

	  var KEY = 'rediPlusVersion';

	  that.set = function (version) {
	    window.localStorage.setItem(KEY, version);
	  };

	  that.get = function () {
	    return window.localStorage.getItem(KEY);
	  };
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ ["openFinApi", "OpenfinWindowManager", "BrowserWindowManager", function (openFinApi,
	                                           OpenfinWindowManager,
	                                           BrowserWindowManager) {
	  return openFinApi.isInOpenFin ? OpenfinWindowManager : BrowserWindowManager;
	}];


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function (angularModule) {
	  angularModule
	      .value('openFinWebLibFeatures', __webpack_require__(22))
	      .run(__webpack_require__(23));
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  enableHideTaskbarIcon: false  // flag to hide or allow toolbar icon and related translations
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ ["$log", "$timeout", "openFinApi", function ($log, $timeout, openFinApi) {
	  openFinApi.getFin().then(function (fin) {
	    preventEventListenerFromLeakingMemoryOnClose(fin);
	  });

	  function preventEventListenerFromLeakingMemoryOnClose(fin) {
	    $log.info('Overriding fin.desktop.Window.prototype.addEventListener method to prevent it from leaking memory on close.');

	    var originalAddEventListener = fin.desktop.Window.prototype.addEventListener;
	    fin.desktop.Window.prototype.addEventListener = function (eventName, eventHandler) {
	      var window = this;
	      var closedEventName = 'closed';
	      var closedEventListener = function () {
	        $timeout(function () {
	          // OpenFin event listeners are stored in array and executed via forEach.
	          // By removing the event listener while it's handling the event, it can skip some listeners.
	          // To workaround the issue, remove the event listeners in timeout to make sure to remove them outside the forEach.
	          window.removeEventListener(closedEventName, closedEventListener);
	          window.removeEventListener(eventName, eventHandler);
	        }, 0);
	      };
	      originalAddEventListener.apply(window, arguments);
	      originalAddEventListener.call(window, closedEventName, closedEventListener);
	    };
	  }
	}];


/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// /app/~/redi-window-container-web-lib-angular/dist/bundle.js
// module id = 35
// module chunks = 0